// eslint-disable-next-line import/extensions
import IonWarningTips from './src/main.js';
/**
 *@author huhongyun
 *@date 2021/10/13
 *@component IonWarningTips - 告警提示组件
 */
export default IonWarningTips;
